<div class="language-switch" #languageWrapper>
  <button type="button" class="action-btn" (click)="toggleLanguage()" title="Language">
    <i class="hgi hgi-stroke hgi-rounded hgi-globe-02"></i>
  </button>
  @if (languageDropdown) {
    <ul class="dropdown-menu">
      <li><a (click)="switchLanguage('en')" class="nav-link-sm">English</a></li>
      <li><a (click)="switchLanguage('fr')" class="nav-link-sm">Français</a></li>
      <li><a (click)="switchLanguage('es')" class="nav-link-sm">Español</a></li>
      <li><a (click)="switchLanguage('de')" class="nav-link-sm">Deutsch</a></li>
      <li><a (click)="switchLanguage('ar')" class="nav-link-sm">العربية</a></li>
      <li><a (click)="switchLanguage('ja')" class="nav-link-sm">日本語</a></li>
      <li><a (click)="switchLanguage('ms')" class="nav-link-sm">Bahasa Melayu</a></li>
      <li><a (click)="switchLanguage('id')" class="nav-link-sm">Bahasa Indonesia</a></li>
    </ul>
  }
</div>
